module.exports = __webpack_public_path__ + "img/1-low.043e21ff.jpg";